import $ from 'jquery';
import Globals from '../helpers/Globals';

const { $body, $window } = Globals;

const Share = {
    init() {
        $body.on('click', '.js-share-link', e => this.shareLink(e));
    },

    shareLink(e) {
        e.preventDefault();

        const $curr = $(e.currentTarget);
        const type = $curr.attr('data-type') || 'facebook';
        const text = $curr.attr('data-text') || 'LIFE Sparc | ...';
        const url = $curr.attr('data-share-url') || window.location.href;
        let href = '';

        switch (type) {
            case 'facebook': {
                href = 'https://www.facebook.com/share.php?u=' + encodeURIComponent(url);
                break;
            }
            case 'twitter': {
                href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(text + ' ' + url);
                break;
            }
            case 'linkedin': {
                href = 'https://www.linkedin.com/shareArticle?mini=true&title=' + encodeURIComponent(text) + ' &url=' + encodeURIComponent(url) + '&source=LinkedIn';
                break;
            }
            case 'email': {
                window.location = 'mailto:?subject=' + encodeURIComponent(text) + '&body=' + encodeURIComponent(url);
                return;
            }
            default: {
                href = '';
                break;
            }
        }

        this.shareWindow(href);
    },

    shareWindow(href) {
        const windowDualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top;
        const windowDualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left;
        const windowWidth = 600;
        const windowHeight = 400;
        const windowTop = ($window.height() / 2) - (windowHeight / 2) + windowDualScreenTop;
        const windowLeft = ($window.width() / 2) - (windowWidth / 2) + windowDualScreenLeft;
        const newWindow = window.open(href, '', 'width=' + windowWidth + ', height=' + windowHeight + ', top=' + windowTop + ', left=' + windowLeft);

        if (window.focus) newWindow.focus();
    },
};

export default Share;
